module.exports = __webpack_public_path__ + "media/images/skebi/icon-armchair-bbb8afb294992052f086ef4c1fdc2838.png";